import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import "../CSS/appointment.css"
import Checkbox from '../Components/Checkbox.js';
import TextField from '@material-ui/core/TextField';
//import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'

export class Upgrade extends Component {
  constructor(props) {
    super(props)
    this.state = {
      upgrade: props.upgrade,
      isChecked:false
    }
  }
  componentWillReceiveProps(nextProps) {

  }
  handleChange = label => {
    this.props.handleCheckBox(label)
  }
  checkBox = () => {
    this.setState({
      isChecked:!this.state.isChecked
    })
  }
  render() {
    var amount = this.state.upgrade.amount
    if(amount > 0){
      amount = amount/100
    }
    return (
      <div className="card upgradeCard" onClick={()=> this.child.toggleCheckboxChange()}>
        <div className="card-header text-white">
          <h5 className="text-left d-inline">{this.state.upgrade.display_title}<span className="badge badge-default float-right">${amount}</span></h5>
        </div>
        <div className="card-body">
        <Checkbox
          ref = {instance => { this.child = instance; }}
          isChecked={this.state.isChecked}
          checkBox = {this.checkBox}
          label={JSON.stringify(this.state.upgrade)}
          handleCheckboxChange={this.handleChange}
          key={"1"}
       />
          <p className="card-text text-justify marginLeft" dangerouslySetInnerHTML={{ __html:this.state.upgrade.display_blurb}}></p>
          {(this.props.upgrade && this.props.upgrade.promotional_image_url) &&
            <img className="promotionalImage" src={this.props.upgrade.promotional_image_url}></img>
          }
        </div>
      </div>
    )
  }
}
export default Upgrade



// WEBPACK FOOTER //
// ./src/Components/Upgrade.js